import { render } from "./EventCard.vue?vue&type=template&id=c7a2ad74&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=c7a2ad74&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c7a2ad74"

export default script